import React from 'react';

export const defaultValue = {
  isModal: false,
  closeTo: null,
  prevModalUrl: null,
};
const ModalRoutingContext = React.createContext(defaultValue);

export default ModalRoutingContext;
